// set function parseTime,formatTime to filter
export { parseTime, formatTime } from '@/utils'

export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

export function sexFilter(val) {
  if (val === 0) {
    return '男'
  } else if (val === 1) {
    return '女'
  } else {
    return ''
  }
}
/* 数字 格式化*/
export function numberFormatter(num, digits) {
  const si = [
    { value: 1e18, symbol: 'E' },
    { value: 1e15, symbol: 'P' },
    { value: 1e12, symbol: 'T' },
    { value: 1e9, symbol: 'G' },
    { value: 1e6, symbol: 'M' },
    { value: 1e3, symbol: 'k' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
    }
  }
  return num.toString()
}

export const filTime = (val, type) => {
  const date = new Date()
  if (!val || val <= 5) {
    return val
  }

  if (!/^\d+$/.test(val)) {
    return val
  }

  if (!type) {
    return val.toString().replace(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1-$2-$3 $4:$5:$6')
  }

  let mytime = val
  if (val.toString().length <= 10) {
    mytime = val * 1000
  }

  date.setTime(mytime)
  const hms = date.toString().match(/\d{2}:\d{2}:\d{2}/g)
  if (!hms) {
    return '错误时间'
  }

  const time = date.toLocaleDateString() + ' ' + hms[0]

  switch (type) {
    case 7: // 如 1999-1-1
      return time.replace(/\/(\d+)\/(\d+)\ (\d+):(\d+):(\d+)/, '-$1-$2')
    case 1: // 年 月 日  时 分 秒
      return time.replace(/\/(\d+)\/(\d+)\ (\d+):(\d+):(\d+)/, '年$1月$2日 $3时$4分$5秒')
    case 2: // 如 1999-1-1  09：00：50
      return time.replace(/\/(\d+)\/(\d+)\ (\d+):(\d+):(\d+)/, '-$1-$2  $3:$4:$5 ')
    case 3:
      return (
        time.replace(/\/(\d+)\/(\d+)\ (\d+):(\d+):(\d+)/, '-$1-$2  $3:$4:$5 ') +
        '星期' +
        '日一二三四五六七'.charAt(date.getDay())
      )
    case 4: // 如 1999-1-1  09：00：50
      return time.replace(/\/(\d+)\/(\d+)\ (\d+):(\d+):(\d+)/, '-$1-$2  $3:$4')
    case 5:
      return time.replace(/\/(\d+)\/(\d+)\ (\d+):(\d+):(\d+)/, '/$1/$2 $3:$4')
    case 6: // 如 1999-01-01  09：00：50
      var reg = /(\d+)\/(\d+)\/(\d+)\ (\d+):(\d+):(\d+)/
      let time1 = time.replace(reg, (a, b, c, d, e, f, g) => {
        return `${b}-${c.length > 1 ? c : `0${c}`}-${d.length > 1 ? d : `0${d}`} ${e}:${f}:${g}`
      })
      return time1
    case 'yy-mm-dd': // 返回 年 月 日
      return date.toLocaleDateString()
    case 'hh-mm-ss':
      return hms
    case 'hh-mm':
      // console.log("hh--mmm",hms.replace(/:[^:]+$/,''));
      return hms[0].replace(/:[^:]+$/, '')
    case 'yy-mm': // 返回 年 月
      return date.getFullYear() + '-' + (date.getMonth() + 1)
    default:
      return time
  }
}
export const timehms = result => {
  let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600)
  let m = Math.floor((result / 60) % 60) < 10 ? '0' + Math.floor((result / 60) % 60) : Math.floor((result / 60) % 60)
  let s = Math.floor(result % 60) < 10 ? '0' + Math.floor(result % 60) : Math.floor(result % 60)
  if (h == 0) {
    return m + ':' + s
  } else {
    return h + ':' + m + ':' + s
  }
}
export const fileNameExt = val => {
  if (!val) return ''
  let newVal = val.substring(val.lastIndexOf('/') + 1)
  return decodeURIComponent(newVal)
}

export const fileType = val => {
  if (!val) return ''
  let newVal = val.substring(val.lastIndexOf('.'))
  return newVal
}
